<div class="col-xl-10 col-lg-10 col-md-10 order-0 order-md-1">

    <div class="mb-2 retour"  (click)="retour()">

        <i data-feather="arrow-left" [size]="20"> </i>
        Retour
    </div>
    <!-- Customer Pills -->
    <div class="nav-align-top">
        <ul class="nav nav-pills flex-column flex-md-row mb-6 row-gap-2">
            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/achat"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                ><i class="bi bi-file-earmark-check" style="font-size: 20px"></i>

                    Inventaire
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/achat/commande-fornisseur"
                        routerLinkActive="active"
                >
                    <i data-feather="shopping-cart" [size]="20"></i>Commande fournisseur
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/achat/facture-fornisseur"
                        routerLinkActive="active"
                >
                    <i data-feather="file" [size]="20"></i>Facture fournisseur
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/achat/bon-livraison"
                        routerLinkActive="active"
                >
                    <!-- <i data-feather="file-plus" [size]="20"></i>-->
                    <i class="bi bi-file-earmark-arrow-up" style="font-size: 20px"></i>
                    Bon de réception
                </a>
            </li>

        </ul>
    </div>

    <div class="row text-nowrap">
        <div class="container">
            <router-outlet></router-outlet>
        </div>


    </div>


</div>